module.exports = __webpack_public_path__ + "static/media/icon_ritsuacdd0c9e53de681bb3c8538f53feb19b.webp";